export const reviewReduxConstants = {
  SET_REVIEW_LIST_ITEMS: 'SET_REVIEW_LIST_ITEMS',
  SET_REVIEW_DETAILS: 'SET_REVIEW_DETAILS',
  SET_REVIEWS_SEARCH_RESULT: 'SET_REVIEWS_SEARCH_RESULT',
  RESET_REVIEWS_STATE: 'RESET_REVIEWS_STATE',
};

export const MINIMUM_AMOUNT_OF_REVIEWS_REQUIRED = 5;
